import React, { useEffect, useState, useContext } from "react";
import { Box, CircularProgress, Alert } from "@mui/material";
import { SidebarContext } from "../Sidebar/SidebarProvider";
import { useParams } from "react-router-dom";

import { jwtDecode } from "jwt-decode";

import {
  getExpenseDocument,
  getExpenseSummary,
} from "../../api/Expenses/expenseDocumentDetailApi";

import ExpenseDocumentHeader from "./ExpenseDocumentHeader";
import ExpenseDocumentSummary from "./ExpenseDocumentSummary";
import ExpenseDocumentTabs from "./ExpenseDocument/ExpenseDocumentTabs"; // ✅ CORREGIDO

const ExpenseDocument = () => {
  const { isMinimized, contentMargin } = useContext(SidebarContext);
  const marginLeft = isMinimized ? "3em" : "3em";

  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const isSuperman = decoded.permisoVertodoExpenses;

  const { id } = useParams();
  const documentId = Number(id);

  const [document, setDocument] = useState(null);
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 🔄 Recargar solo el summary (lo usaremos luego)
  const loadSummary = async () => {
    const sum = await getExpenseSummary(documentId);
    setSummary(sum);
  };

  useEffect(() => {
    let mounted = true;

    const load = async () => {
      if (!Number.isInteger(documentId)) {
        setError("Documento de gastos inválido");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        const [doc, sum] = await Promise.all([
          getExpenseDocument(documentId),
          getExpenseSummary(documentId),
        ]);

        if (!mounted) return;

        setDocument(doc);
        setSummary(sum);
      } catch (err) {
        console.error(err);
        if (!mounted) return;
        setError("No se pudo cargar el documento de gastos");
      } finally {
        if (mounted) setLoading(false);
      }
    };

    load();

    return () => {
      mounted = false;
    };
  }, [documentId]);

  // ⏳ Loading
  if (loading) {
    return (
      <Box
        sx={{
          marginLeft,
          ...contentMargin,
          p: 4,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // ❌ Error
  if (error) {
    return (
      <Box sx={{ marginLeft, ...contentMargin, p: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (!document || !summary) return null;

  // 🔒 Estado de bloqueo (NO se usa aún, solo se calcula)
  const isLocked = document.Status !== "draft" && !isSuperman;

  return (
    <Box sx={{ marginLeft, ...contentMargin, p: 4 }}>
      <ExpenseDocumentHeader
        document={document}
        isLocked={isLocked} // ✅ preparado
      />
      <ExpenseDocumentSummary summary={summary} />
      <ExpenseDocumentTabs
        documentId={document.id}
        status={document.Status}
        isLocked={isLocked} // ✅ preparado
        onRefreshSummary={loadSummary}
      />
    </Box>
  );
};

export default ExpenseDocument;
